import React from 'react';
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
// import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
// import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded'
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'

import {
    Button,
} from '@themesberg/react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { CopyAllRounded, PlusOneRounded } from '@mui/icons-material';

const ActionMenu = (props) => {
    const {
        isHidden,
        handleCreateEdit,
        handleDelete,
        thumbnail,
        name,
        data,
        bannerType, id, handleUpdate, SABanners } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl)
    const navigate = useNavigate()



    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    return (
        <>
            <>
                <Button
                    variant='btn text-btn'
                    id='basic-button'
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup='true'
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right'
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                >
                    <MoreVertRoundedIcon />
                </Button>
                <Menu
                    id='basic-menu'
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}

                >

                    <MenuItem onClick={handleClose} hidden={isHidden({ module: { key: 'BannerManagement', value: 'U' } })}>
                        <Button
                            variant='btn text-btn'
                            onClick={() => handleCreateEdit('Update', { thumbnail: thumbnail, name: name, url: thumbnail, pageBannerId: id })}
                        >
                            <BorderColorRoundedIcon />
                            <span className='text'>Update</span>
                        </Button>
                    </MenuItem>


                    <MenuItem onClick={handleClose} hidden={isHidden({ module: { key: 'BannerManagement', value: 'D' } })}>
                        <Button
                            variant='btn text-btn'
                            onClick={() => handleDelete(parseInt(id), name)}
                        >
                            <DeleteForeverOutlinedIcon />
                            <span className='text'>Delete</span>
                        </Button>
                    </MenuItem>



                </Menu>


                {/* <Menu
                    id='basic-menu'
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button'
                    }}
                    hidden={isHidden({ module: { key: 'BannerManagement', value: 'U' } })}
                >
                    <MenuItem onClick={handleClose}>
                        <Button
                            variant='btn text-btn'
                            onClick={() => handleCreateEdit('Update', {thumbnail: thumbnail , name: name ,url : thumbnail, pageBannerId: id })}
                        >
                            <DeleteForeverOutlinedIcon />
                            <span className='text'>Update</span>
                        </Button>
                    </MenuItem>

                </Menu> */}



            </>
        </>
    )
};

export default ActionMenu;